"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { CreditUsageBar } from "@/components/billing/CreditUsageBar";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { useDeferredShellUi } from "@/hooks/useDeferredShellUi";
import { cn } from "@/lib/utils";
import { useCreditStore } from "@/stores/useCreditStore";
interface ShellGlobalActionsProps {
  className?: string;
  creditVariant?: "default" | "inline";
  popoverSide?: "top" | "right" | "bottom" | "left";
  popoverAlign?: "start" | "center" | "end";
}

/**
 * Credits and notifications for hub and workbench chrome — not the left rail.
 */
export function ShellGlobalActions(t0) {
  const $ = _c(19);
  const {
    className,
    creditVariant: t1,
    popoverSide: t2,
    popoverAlign: t3
  } = t0;
  const creditVariant = t1 === undefined ? "inline" : t1;
  const popoverSide = t2 === undefined ? "bottom" : t2;
  const popoverAlign = t3 === undefined ? "end" : t3;
  const pathname = usePathname();
  const showDeferredUi = useDeferredShellUi();
  const creditBalance = useCreditStore(_temp);
  const isBillingView = pathname === "/dashboard/billing";
  if (!showDeferredUi) {
    let t4;
    if ($[0] !== className) {
      t4 = cn("flex items-center gap-1", className);
      $[0] = className;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="h-9 w-16 rounded-md bg-muted/50" />;
      t6 = <div className="h-9 w-9 rounded-md bg-muted/50" />;
      $[2] = t5;
      $[3] = t6;
    } else {
      t5 = $[2];
      t6 = $[3];
    }
    let t7;
    if ($[4] !== t4) {
      t7 = <div className={t4} aria-hidden={true}>{t5}{t6}</div>;
      $[4] = t4;
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    return t7;
  }
  let t4;
  if ($[6] !== className) {
    t4 = cn("flex shrink-0 items-center gap-1", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== creditBalance || $[9] !== creditVariant || $[10] !== isBillingView) {
    t5 = !isBillingView ? <CreditUsageBar balance={creditBalance} variant={creditVariant} /> : null;
    $[8] = creditBalance;
    $[9] = creditVariant;
    $[10] = isBillingView;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== popoverAlign || $[13] !== popoverSide) {
    t6 = <NotificationBell popoverSide={popoverSide} align={popoverAlign} />;
    $[12] = popoverAlign;
    $[13] = popoverSide;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp(s) {
  return s.balance;
}